<template>
  <div class="row justify-center">
    <div class="full-width width-custom relative-position">
      <slot></slot>
      <transition
        mode="out-in"
        enter-active-class="animated slideInLeft"
        leave-active-class=" animated slideOutLeft"
      >
        <slot name="back-button">
          <div class="fixed" style="top: 4px; z-index: 2999;" v-show="showBackButton">
            <q-btn @click="backTrigger" flat round class="q-btn--hide-focus-helper m-shadow-helper">
              <q-icon center size="2.5rem" color="primary" name="keyboard_arrow_left" />
            </q-btn>
          </div>
        </slot>
      </transition>
      <div style="position: absolute; top: 4px; right: 7px; z-index: 2999;" v-show="showLangSelector">
        <LangSelector />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LangSelector from 'src/components/ui/LangSelector'

export default {
  name: 'BaseHeaderFrame',
  components: {
    LangSelector
  },
  computed: {
    ...mapGetters([
      'prevRouteName'
    ]),
    showBackButton () {
      let output = true
      let { name } = this.$route
      if (
        (name === 'index') ||
        !this.prevRouteName
      ) {
        output = false
      }
      return output
    },
    showLangSelector () {
      const isIframe = this.$q.platform.within.iframe
      return !isIframe
    }
  },
  methods: {
    backTrigger () {
      this.$router.back()
    }
  }
}
</script>
